import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import ButtonOutline1 from './button-outline1'
import './blog-card-blogs.css'

const BlogCardBlogs = (props) => {
  return (
    <div className={`blog-card-blogs-blog-post-card ${props.rootClassName} `}>
      <img
        id="blogimage"
        alt={props.imageAlt1}
        src={props.imageSrc}
        loading="lazy"
        className="blog-card-blogs-image"
      />
      <div className="blog-card-blogs-container1">
        <div className="blog-card-blogs-container2">
          <span className="blog-card-blogs-text1">{props.when}</span>
        </div>
        <h1>{props.blogTitle}</h1>
        <span className="blog-card-blogs-text3">
          {props.text ?? (
            <Fragment>
              <span className="blog-card-blogs-text4">
                <span>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                  non volutpat turpis. Mauris luctus rutrum mi ut rhoncus.
                  Integer in dignissim tortor. Lorem ipsum dolor sit amet,
                  consectetur adipiscing ...
                </span>
              </span>
            </Fragment>
          )}
        </span>
        <div className="blog-card-blogs-container3">
          <ButtonOutline1
            text="Lees meer"
            imageAlt="Lees meer"
            rootClassName="button-outline1root-class-name6"
          ></ButtonOutline1>
        </div>
      </div>
    </div>
  )
}

BlogCardBlogs.defaultProps = {
  imageSrc:
    'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NDYzOTc2MHw&ixlib=rb-4.0.3&q=80&w=400',
  imageAlt1: 'image',
  text: undefined,
  blogTitle: 'Lorem ipsum dolor sit amet',
  when: '3 days ago',
  rootClassName: '',
}

BlogCardBlogs.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt1: PropTypes.string,
  text: PropTypes.element,
  blogTitle: PropTypes.string,
  when: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default BlogCardBlogs
